var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"innerContainer"},[(_vm.data)?_c('div',{staticClass:"tela-politica-termos"},[_c('h1',[_vm._v("Declaração de privacidade")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.text)}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }